import UpdateAgent from './UpdateAgent';
export default UpdateAgent;
